import React, { ReactElement, Suspense, useRef } from 'react';
import { Router } from 'react-router-dom';
import Loader from '../../common/components/loader';
import Public from './Public';
import history from '../../utils/history';
const RouteLoader = (): ReactElement | null => {
	return (
		<React.Fragment>
			<Router history={history} >
				<Suspense fallback={<Loader />}>
					<Public />
				</Suspense>
			</Router>
		</React.Fragment>
	);
};

export default RouteLoader;
